import DatepickerInFullscreen from './directives/datepicker-in-fullscreen/datepicker-in-fullscreen.js'

import {
  required,
} from 'vuelidate/lib/validators'
const noavailable1='NO AVAILABILITY WITHIN CHOSEN TIME OR DATES';
const noavailable2='NO AVAILABILITY WITHIN CHOSEN TIME PERIOD';
export default {
  directives: {
    DatepickerInFullscreen
  },
  data() {
    return {
      disabledOptions: {
        'ALL DAY': 0,
        'MORNING': 0,
        'EVENING': 0,
      },
      hasAvailables: true,
      hasAvailablesMessage: noavailable1,
      bookWidget: {
        date: this.$date,
        timeOfDay: this.$timeOfDay,
      },
    }
  },
  validations() {
    let validations = {
      bookWidget: {
        date: {
          required
        },
        timeOfDay: {
          required
        }
      }
    }
    return validations
  },
  watch: {
    bookWidget: {
      handler: function (newValue) {
        this.hasAvailables = true;
        Vue.prototype.$date = newValue.date
        Vue.prototype.$timeOfDay = newValue.timeOfDay
      },
      deep: true
    }
  },
  methods: {
    openBookModal() {
      const component = this

      component.$v.bookWidget.$touch()

      if (component.$v.bookWidget.$invalid) {
        let invalidField

        Object.keys(component.$v.bookWidget.$params).some(function (item) {
          invalidField = Object.keys(component.$v.bookWidget).find(key => component.$v.bookWidget[key].$invalid);
          return invalidField
        })

        component.$scrollTo(document.getElementById(invalidField), 1000, {
          offset: -150,
        })
      } else {
        this.validateAvailability();
      }
    },
    validateAvailability() {
      const component = this;

      component.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': window.Laravel.csrfToken
      };
      var _url = '/' + window.Laravel.code + '/book/validate';
      component.axios.post(_url, component.bookWidget)
        .then(function (response) {
          var _data = response.data;

          if (_data.length == 0) {
            component.hasAvailablesMessage = noavailable1;
            component.hasAvailables = false;
          } else if (_data.length == 1) {
            console.log(_data.indexOf(component.bookWidget.timeOfDay));
            if(_data.indexOf(component.bookWidget.timeOfDay)==-1){
              // component.bookWidget.timeOfDay = null;
              component.hasAvailables = false;
              component.hasAvailablesMessage = noavailable2;
            }else{
              component.hasAvailables = true;
            }
          } else {
            component.hasAvailablesMessage = noavailable1;
            component.hasAvailables = true;
          }

          if(component.hasAvailables)
          {
            component.$root.$refs['book-modal'].show();
          }
        })
        .catch(function (error) {
          console.log('error:', error)
        });
    }
  }
}